import React from "react";
import "./Loading.scss";
import { Modal, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import PropTypes from "prop-types";

export default function Loading({ isLoadingVisible }) {
  const antIcon = <LoadingOutlined style={{ fontSize: 40 }} spin />;
  return (
    <Modal title="提示" visible={isLoadingVisible}>
      <Spin indicator={antIcon} />
      <p>Loading...</p>
    </Modal>
  );
}

Loading.propTypes = {
  isLoadingVisible: PropTypes.bool.isRequired,
};
